<template>
  <div class="bulk-invoices">
    <data-table :service="service"
                :entity="entity"
                :columns="columns"
                :filters="filters"
                operations="refresh"
                :go-to-details-on-row-click="false"
                service-method="getInvoiceLinesPerClient"
                ref="table">
      <template slot="table-header-left"
                :placeholder="$t('invoiceLines.list.labels.selectDate')">
        <el-date-picker v-model="dateRange"
                        type="daterange"
                        format="dd MMM yyyy"
                        value-format="yyyy-MM-dd"
                        :range-separator="$t('datePicker.to')"
                        :start-placeholder="$t('datePicker.startPlaceholder')"
                        :end-placeholder="$t('datePicker.endPlaceholder')"
                        :picker-options="pickerOptions"/>
      </template>

      <div class="d-flex align-items-center" slot="client_name" slot-scope="{row}">
        <base-avatar :name="row.client_name"/>
        <div class="ml-2 font-weight-bold">{{row.name}}</div>

        <router-link class="ml-2 font-weight-bold" :to="`/contacts/clients/${row.client_uuid}`">
          {{row.client_name}}
        </router-link>
      </div>

      <div class="flex flex-column" slot="price_ex" slot-scope="{row}">
        <div>
          {{parseFloat(row.price_ex) | toCurrency}}
          <small>{{$t('generic.exclVAT')}}</small>
        </div>
        <div class="mt-1">
          {{parseFloat(row.price_in) | toCurrency}}
          <small>{{$t('generic.inclVAT')}}</small>
        </div>
      </div>

      <template slot="extra-buttons" slot-scope="{row}">
        <base-button :loading="row.loading"
                     outline
                     @click="generateInvoice(row)"
                     size="sm">
          {{$t('invoiceLines.list.labels.makeInvoice')}}
        </base-button>
      </template>
    </data-table>
  </div>
</template>
<script>
  import { DatePicker } from 'element-ui'
  import enitites from 'src/config/entities'
  import InvoiceService from 'src/services/InvoiceService'
  import InvoiceLinesService from 'src/services/InvoiceLinesService'
  import { getDateRange, dateRanges } from 'src/config/dateUtils'

  export default {
    name: 'bulk-invoices',
    components: {
      [DatePicker.name]: DatePicker,
    },
    data () {
      return {
        entity: enitites.INVOICE_LINE,
        service: InvoiceLinesService,
        filterDate: new Date(),
        dateRange: getDateRange(dateRanges.MONTH),
        pickerOptions: {
          shortcuts: [
            {
              text: this.$t('datePicker.shortcuts.lastWeek'),
              onClick (picker) {
                picker.$emit('pick', getDateRange(dateRanges.WEEK))
              }
            },
            {
              text: this.$t('datePicker.shortcuts.lastMonth'),
              onClick (picker) {
                picker.$emit('pick', getDateRange(dateRanges.MONTH))
              }
            }, {
              text: this.$t('datePicker.shortcuts.lastThreeMonths'),
              onClick (picker) {
                picker.$emit('pick', getDateRange(dateRanges.THREE_MONTHS))
              }
            }]
        }
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'client_name',
            label: this.$t('invoiceLines.list.labels.client'),
            minWidth: '175px',
            sortable: true
          },
          {
            prop: 'price_ex',
            label: this.$t('invoiceLines.list.labels.priceEx'),
            minWidth: '190px',
            sortable: true
          },
          {
            prop: 'total',
            label: this.$t('invoiceLines.list.labels.lineCount'),
            minWidth: '175px',
            sortable: true,
            align: 'center'
          },
        ]
      },
      filters () {
        let filterArr = []
        if (this.dateRange && this.dateRange.length > 1) {
          filterArr.push({
            key: 'from',
            value: this.dateRange[0],
          })
          filterArr.push({
            key: 'to',
            value: this.dateRange[1],
          })
        }
        return filterArr
      }
    },
    methods: {
      async generateInvoice (row) {
        try {
          this.$set(row, 'loading', true)
          const requestData = {
            client_uuid: row.client_uuid,
          }
          if (this.dateRange && this.dateRange.length > 1) {
            requestData.bulk_invoice_from = this.dateRange[0]
            requestData.bulk_invoice_till = this.dateRange[1]
          }
          await InvoiceService.generateInvoiceForClient(requestData)
          this.$refs.table.refresh()
        } finally {
          this.$set(row, 'loading', false)
        }
      }
    }
  }
</script>
<style lang="scss">
  .bulk-invoices {
  }
</style>
